import { render, staticRenderFns } from "./polaris-banner.vue?vue&type=template&id=6d4430de&"
import script from "./polaris-banner.vue?vue&type=script&lang=js&"
export * from "./polaris-banner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports